/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import performance from '@atlassian/jira-common-performance/src/performance.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createHook,
	createSubscriber,
	type BoundActions,
	type HookFunction,
	type SubscriberComponent,
} from '@atlassian/react-sweet-state';
import Store from '../../store.tsx';
import type { State, TransitionState, PageTiming, VisitedPages } from '../../types.tsx';
import type { Actions } from '../../actions/page-events/index.tsx';

const getNavigationStart = () => {
	const timestamp = performance && performance.timing && performance.timing.navigationStart;
	return timestamp ? new Date(timestamp).toISOString() : undefined;
};

const getLastTransition = (currentPage: PageTiming, visitedPages: VisitedPages) => {
	if (visitedPages.length === 0) {
		return undefined;
	}

	const collectAppNames = (page: PageTiming) => Object.keys(page.apps || {}).sort();
	const appNamesToStr = (appNames: Array<string>) => appNames.join('+') || '?';

	const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
	const currPage = appNamesToStr(collectAppNames(currentPage));

	return `${prevPage} > ${currPage}`;
};

const getLastTransitionStartTime = (currentPage: PageTiming, visitedPages: VisitedPages) => {
	// If there are no previously visited pages the transition didn't have a place
	if (visitedPages.length === 0) {
		return undefined;
	}

	return currentPage.startTime;
};

export const selector = ({ visitedPages, currentPage }: State): TransitionState => ({
	isInitialRender: visitedPages.length === 0,
	transitionsCount: visitedPages.length,
	lastTransition: getLastTransition(currentPage, visitedPages),
	lastTransitionStartTime: getLastTransitionStartTime(currentPage, visitedPages),
	navigationStart: getNavigationStart(),
	currentPageId: currentPage.uuid,
});

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
type Subscriber = SubscriberComponent<TransitionState, Actions, Record<any, any>>;
// @ts-expect-error - TS2322 - Type 'SubscriberComponent<TransitionState, BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/spa-state-controller/src/actions/index")>, Record<...>>' is not assignable to type 'Subscriber'.
const SpaStateTransitionStateSubscriber: Subscriber = createSubscriber<
	State,
	Actions,
	TransitionState,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<any, any>
>(Store, {
	displayName: 'SpaStateTransitionStateSubscriber',
	selector,
});

export const useSpaStateTransition: HookFunction<
	TransitionState,
	BoundActions<State, Actions>,
	void
> = createHook(Store, {
	selector,
});

export default SpaStateTransitionStateSubscriber;
